import Control from '../1. Core/Control';
import DataTable from '../1. Core/Controls/DataTable/DataTable';
import TopAppBar from '../1. Core/Controls/TopAppBar/TopAppBar';
import Delegate from '../1. Core/Delegate';
import './FantasyList.scss';
import {Card, CardStatus} from './types';
import NP from "../1. Core/NP";
import {ServerAPI} from "../1. Core/ServerAPI";
import ListItem from "../1. Core/Controls/ListBox/ListItem";
import Menu from "../1. Core/Controls/Menu/Menu";
import EditUserCardDialog from "./EditUserCardDialog";
import GrantFighterCardV2Dialog from "./GrantFighterCardV2Dialog";
import Dialog from "../1. Core/Controls/Dialog/Dialog";
import Select from "../1. Core/Controls/Select/Select";
import NumField from "../1. Core/Controls/TextField/NumField";
import ListBox from "../1. Core/Controls/ListBox/ListBox";


export default class UserCards extends Control {
	private _topAppBar: TopAppBar;
	private EvClosed: Delegate;

	private _dataTable: DataTable;
	private _dataWithFiltersNode: HTMLElement;
	private _UserId: number;

	constructor(settings: object)
	{
		super(settings);
		this._render();
	}

	_initFields(settings: object)
	{
		this._UserId = null;
		this.EvClosed = new Delegate();
		super._initFields(settings);
	}

	_render()
	{
		this.np_render();
		this.addClass('');


		this._topAppBar = new TopAppBar({
			Class: 'top-app-bar--no-shadow top-app-bar--light library-box-list__app-bar',
			Caption: 'User cards',
			ParentNode: this._root,
			ShowSearchButton: false,
			MainButton: {
				FontImage: NP.FontImages.arrow_back,
				EvClick: () => this.EvClosed.fire(this)
			},
			RightItems: [{
				ToolTip: 'Lottery package',
				FontImage: NP.FontImages.palette,
				EvClick: () => this.lotteryCard('Package')
			}, {
				ToolTip: 'Grant fighter card v2',
				FontImage: NP.FontImages.fight_tt,
				EvClick: () => this.showGrantFighterCardV2Dialog()
			}, {
				ToolTip: 'Add card',
				FontImage: NP.FontImages.add,
				EvClick: () => this.showAddCardToUserDialog()
			}
			]
		});

		this._dataWithFiltersNode = NP.createNode(this._root, 'data-with-filters-container');


		this._dataTable = new DataTable({
			ParentNode: this._dataWithFiltersNode,
			ShowSettingsButton: NP.getCurrentUser().isBDAdmin(),
			Class: 'app-list--avatars mdc-data-table--margin data-table-battle',
			MultiSelect: false,
			ShowRowIndex: false,
			EnableSort: false,
			Width: this._Width,
			Height: this._Height - 64,
			ImageWidth: 32,
			Columns: [{
				Content: NP.RM.getString('Name'),
				PropertyContent: 'name',
				Width: '20%'
			}, {
				Content: 'Info',
				PropertyContent: 'exDescData',
				Width: '20%'
			}, {
				Content: 'Use type',
				PropertyContent: 'timeuse',
				Width: '20%'
			}, {
				Content: 'Coef',
				PropertyContent: 'statusCoef',
				Width: '5%'
			}, {
				Content: 'Status',
				PropertyContent: 'status',
				Width: '20%'
			}, {
				Content: 'Created',
				Width: '20%',
				PropertyContent: 'created'
			},{
				Content: 'Used Battle Id',
				Width: '10%',
				PropertyContent: 'useInBattleId'
			}],
			ShowPaginator: false,
			EvItemContextMenu: async (s: any, e: { Event: any, Item: Card }) =>
			{
				if (!NP.getCurrentUser().isBDAdmin())
					return;

				let card = e.Item;

				let menu = new Menu({
					Items: [{
						FontImage: NP.FontImages.edit,
						RK: 'Edit',
						Value: 'Edit'
					}, {
						FontImage: NP.FontImages.delete,
						RK: 'Remove',
						Value: 'Remove'
					}],
					EvItemSelected: async (s: Menu, args: { Item: ListItem }) =>
					{
						switch (args.Item.getValue())
						{
							case 'Edit':
								(new EditUserCardDialog({
									UserId: this._UserId,
									Card: card,
									EvOkButtonClick: () => this.refresh()
								})).show()
								break;
							case 'Remove':
								NP.showConfirm({
									RK: 'AreYouS',
									EvOkButtonClick: async () =>
									{
										await ServerAPI.delet(`/cards/user-card/${card.id}`)
										this.refresh()
									}
								}).show();

								break;
						}
					}
				});
				menu.showContextMenu(e.Event);
			}
		});

		this.refresh()
	}


	setHeight(value: number)
	{
		super.setHeight(value);
		let h = this._Height - this._topAppBar.getOffsetHeight();
		this._dataTable.setHeight(h);

	}

	setWidth(value: number)
	{
		super.setWidth(value);
		this._dataTable.setWidth(value);
		if (this._dataTable.getIsSmall())
		{
			this._topAppBar.removeClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
		else
		{
			this._topAppBar.addClass('top-app-bar--no-shadow');
			this.setHeight(this._Height);
		}
	}

	async refresh()
	{
		let cards = await ServerAPI.get<Card[]>(`/cards/getUserCards/${this._UserId}`)

		this._dataTable.setRows(cards);
	}

	getTopAppBar()
	{
		return this._topAppBar;
	}

	showAddCardToUserDialog()
	{
		(new EditUserCardDialog({
			UserId: this._UserId,
			EvOkButtonClick: () => this.refresh()
		})).show()
	}

	showGrantFighterCardV2Dialog()
	{
		(new GrantFighterCardV2Dialog({
			UserId: this._UserId,
		})).show();
	}

	private lotteryCard(defaultType: 'One' | 'Package' = 'One')
	{
		const typeSelect = new Select({
			FloatingLabel: 'Type',
			Value: defaultType,
			Items: [
				{Content: 'One card', Value: 'One'},
				{Content: 'Package', Value: 'Package'}
			],
			EvItemSelected: () => updateAnonymizedVisible()
		});
		const statusSelect = new Select({
			FloatingLabel: 'Status',
			Items: [
				{Content: 'Gold', Value: CardStatus.gold},
				{Content: 'Silver', Value: CardStatus.silver},
				{Content: 'Bronze', Value: CardStatus.bronze},
				{Content: 'Random', Value: 'random'}
			]
		});
		const countField = new NumField({
			FloatingLabel: 'Quantity',
			Value: 1,
			Min: 1,
			Max: 10000,
			FractionCount: 0
		});
		const anonymizedList = new ListBox({
			Items: [
				{Content: 'Assign random athlete', Value: false, IsRadioButton: true},
				{Content: 'Anonymized (no athlete)', Value: true, IsRadioButton: true},
			],
		});
		anonymizedList.setValue(false, false);

		const updateAnonymizedVisible = () => {
			anonymizedList.setIsVisible(typeSelect.getValue() === 'Package');
		};

		(new Dialog({
			Caption: 'Select card status',
			ShowHeader: true,
			Width: 360,
			Height: 480,
			Content: [typeSelect, statusSelect, countField, anonymizedList],
			EvOkButtonClick: async () =>
			{
				const cardStatus = statusSelect.getValue();
				const type = typeSelect.getValue();
				const count = countField.getValue() || 1;
				const anonymousAthlete =
					type === 'Package' && anonymizedList.getValue() === true;

				if (type == 'One')
					await ServerAPI.post(`/cards/lotteryCard/${this._UserId}?status=${cardStatus}&count=${count}`)
				else
					await ServerAPI.post(
						`/cards/lotteryPackage/${this._UserId}?status=${cardStatus}&count=${count}&anonymousAthlete=${anonymousAthlete}`,
					)

				this.refresh();
			}
		})).show();

		updateAnonymizedVisible();
	}

}
